export default {"src":"/_next/static/media/carWithParkingSignPlayground5LightBg_104.5858b0d0.svg","height":104,"width":104,"blurWidth":0,"blurHeight":0};